import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

let searchData = {
  Mail: '',
  PageNumber: 1,
  PageSize: 25
};

let user = JSON.parse(localStorage.getItem("currentUser"));

/* ================= ADD ================= */

export const addSpecialAccessUser = (data) => {
  let url = `${API.AddSpecialAccessUser}`;
  return dispatch => {
    axios.post(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
    .then((response) => {
      dispatch(getSpecialAccessUsersList(searchData));
      dispatch({
        type: "AddSpecialAccessUserSuccess",
        data: response.data
      });
    })
    .catch(() => {
      dispatch({
        type: "AddSpecialAccessUserFailure",
        error: "ERROR"
      });
    });
  };
};

/* ================= UPDATE ================= */

export const updateSpecialAccessUser = (data) => {
  let url = `${API.UpdateSpecialAccessUser}`;
  return dispatch => {
    axios.put(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
    .then((response) => {
      if (response.data) {
        toast.success("Updated Successfully");
      }

      dispatch(getSpecialAccessUsersList(searchData));

      dispatch({
        type: "UpdateSpecialAccessUserSuccess",
        data: response.data
      });
    })
    .catch(() => {
      dispatch({
        type: "UpdateSpecialAccessUserFailure",
        error: "ERROR"
      });
    });
  };
};

/* ================= LIST ================= */

export const getSpecialAccessUsersList = (searchitem) => {
  let url = `${API.SearchSpecialAccessUser}?Mail=${searchitem.Mail}&PageNumber=${searchitem.PageNumber}&PageSize=${searchitem.PageSize}`;

  return dispatch => {
    axios.get(url, {
      headers: {
        key: user.accessToken,
      }
    })
    .then((response) => {
      dispatch({
        type: "GetSpecialAccessUsersSuccess",
        data: response.data
      });
    })
    .catch(() => {
      dispatch({
        type: "GetSpecialAccessUsersFailure",
        error: "ERROR"
      });
    });
  };
};

/* ================= DETAILS ================= */

export const getSpecialAccessUserDetails = (id) => {
  let url = `${API.GetSpecialAccessUserDetails}?specialAccessId=${id}`;

  return dispatch => {
    axios.get(url, {
      headers: {
        key: user.accessToken,
      }
    })
    .then((response) => {
      dispatch({
        type: "GetSpecialAccessUserDetailsSuccess",
        data: response.data
      });
    })
    .catch(() => {
      dispatch({
        type: "GetSpecialAccessUserDetailsFailure",
        error: "ERROR"
      });
    });
  };
};